import styled from 'styled-components';

export const Dropzone = styled.div<{ isDragActive: boolean; hasFile: boolean }>`
  cursor: pointer;
  text-align: center;
  border-radius: ${({ theme }): string => theme.border_radius_x2};
  border-style: dashed;
  border-width: 1px;
  border-color: ${({ theme }): string => theme.palette_blue_100};
  padding: ${({ theme }): string => theme.spacing_unit_x4};
  box-sizing: border-box;
  width: 100%;
  font-weight: 500;

  & > svg {
    margin-bottom: ${({ theme }): string => theme.spacing_unit_x1};
  }

  & > p:last-of-type {
    font-weight: normal;
    margin-top: ${({ theme }): string => theme.spacing_unit_x1};
    color: ${({ theme }): string => theme.palette_primary_100};
    text-decoration: underline;
  }
  ${({ isDragActive, theme }): string =>
    isDragActive ? ` background-color: ${theme.palette_blue_5};` : ''}
  ${({ hasFile, theme }): string =>
    hasFile
      ? `
      background-color: ${theme.palette_blue_5};

      & > svg {
        margin-bottom: 0;
      }

      & > span {
        & > svg {
          width: 32px;
          height: 32px;
        }
        display: block;
        text-align: right;
      }
    `
      : ''}
`;
